module.exports = __webpack_public_path__ + "static/media/polimero-alternativo.cc2bde92.png";